import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSortable } from '@dnd-kit/sortable';
import { Box, Center, Grid } from '@chakra-ui/react';
import { CSS } from '@dnd-kit/utilities';
import { Svg } from '../../../../base';
const DraggableFC = ({ id, isActive, isDisabled, children }) => {
    const { attributes, listeners, setNodeRef, transform } = useSortable({ id });
    const style = {
        transform: CSS.Transform.toString(transform)
    };
    if (!isActive) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsx(Box, { ref: setNodeRef, style: style, children: _jsxs(Grid, { gridTemplateColumns: '24px 1fr', gap: '4px', children: [_jsx(Center, { width: '24px', height: '24px', opacity: isDisabled ? 0.6 : 1, ...listeners, ...attributes, children: _jsx(Svg, { size: "s12", name: "Grab" }) }), _jsx(Box, { children: children })] }) }));
};
export const Draggable = DraggableFC;
//# sourceMappingURL=Draggable.js.map